export const environment = {
  production: false,
  APP_URL: "https://hubnfse.targetit.com.br",
  SOCKET_HOST: "",
  SOCKET_PORT: 6002,
  APP_HUB_CLIENT_ID: 81,
  APP_HUB_CLIENT_SECRET: '8UCHrSbL4XD8zxPT1sM0Ov1rvAUaKb1lE631yEmL',
}